exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dash-hudson-widget[data-v-3e7afcba] {\n  position: relative;\n  overflow: hidden;\n}\n.dash-hudson-widget .ls-container .ls-photo-wrapper[data-v-3e7afcba] {\n  position: relative;\n}\n", ""]);

// exports
